"use client";
import { DEFAULT_SORT } from "src/constants/common";
import { ResultsStore, Types } from "./types";

import { FILTERS_ERROR } from "src/containers/results/constants";
import {
  checkNoResults,
  getSelectedFilters,
  handleSorting,
} from "src/containers/results/utils";
import { Action } from "./action";

export const reducer = (state: ResultsStore, action: Action): ResultsStore => {
  const { type, payload } = action;
  const selectedSort = state.filterList.sortBy.find((item) => item.selected);
  switch (type) {
    case Types.SET_RESULTS_DATA:
      if (selectedSort?.value !== DEFAULT_SORT)
        payload?.buses?.sort(
          state &&
            handleSorting((selectedSort?.value as string) || DEFAULT_SORT)
        );
      return {
        ...state,
        resultsData: payload,
        filterResults: payload,
      };

    case Types.SET_GOVT_BUSES:
      if (selectedSort?.value !== DEFAULT_SORT) {
        const keys = Object.keys(payload);
        keys.forEach((key) => {
          payload[key].sort(
            handleSorting((selectedSort?.value as string) || DEFAULT_SORT)
          );
        });
      }
      return {
        ...state,
        govtBuses: payload,
        filteredGovtBuses: payload,
      };

    case Types.SET_SHOW_FILTERS:
      return {
        ...state,
        showFilters: !state.showFilters,
      };

    case Types.SET_FILTERS_WITH_OPTIONS:
      return {
        ...state,
        filterList: {
          ...state.filterList,
          amenities: payload.amenities,
          pickupPoints: payload.pickupPoints,
          dropOffPoints: payload.dropOffPoints,
          busOperators: payload.busOperators,
        },
      };

    case Types.APPLY_FILTERS:
      const selected = getSelectedFilters(payload.newFilterList);
      const noResults = checkNoResults(payload);

      return {
        ...state,
        filteredGovtBuses: payload.newFilteredGovtBuses,
        selectedFilters: selected,
        filterResults: payload.newFilterResults,
        showFilters: false,
        noResultsFound: noResults
          ? { type: FILTERS_ERROR, value: true }
          : {
              type: {
                TYPE: "",
                TITLE: "",
                MESSAGE: "",
              },
              value: false,
            },

        filterList: payload.newFilterList,
      };

    case Types.NO_RESULTS_FOUND:
      return {
        ...state,
        noResultsFound: { type: payload.type, value: payload.value },
      };

    case Types.SET_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: payload,
      };

    case Types.SET_FILTER_LIST:
      return {
        ...state,
        filterList: payload,
      };

    case Types.SET_RESULTS_LOADING:
      return {
        ...state,
        resultsLoading: payload,
      };

    case Types.CLEAR_CONTEXT_DATA:
      return {
        ...state,
        filteredGovtBuses: {},
        filterResults: {},
        govtBuses: {},
        resultsData: {},
        resultsLoading: true,
        noResultsFound: {
          type: {
            TYPE: "",
            TITLE: "",
            MESSAGE: "",
          },
          value: false,
        },
      };

    case Types.SET_SHOW_SEAT_LAYOUT:
      return {
        ...state,
        showSeatLayout: payload,
      };

    default:
      return state;
  }
};
